import { appendIf, formatDate } from '@btime/helpers'
import { result } from 'lodash'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question?.id === questionId)
}

export const findReplyByFieldId = (replies, fieldId) => {
  return replies.find(reply => reply.field?.id === fieldId)
}

export const filterReplyByQuestionId = (replies, questionId) => {
  return replies.filter(reply => reply.question?.id === questionId)
}

export const getDate = reply => {
  if (!reply) {
    return 'Não informada'
  }
  if (typeof reply === 'string') {
    return formatDate('DD/MM/YYYY', reply)
  }
  if (typeof reply === Date) {
    return formatDate('DD/MM/YYYY', reply)
  }
  return formatDate('DD/MM/YYYY', reply.value)
}

export const toCurrency = value => {
  const invalid_values = ['N/A', '', NaN]
  if (invalid_values.includes(Number(value))) {
    return
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getFieldValue = (fieldValues, fieldName) => {
  return fieldValues.find(fv => {
    return fv.field.name === fieldName
  })
}

export const getQuestionValue = string => {
  return parseInt(string?.substring(string?.indexOf('#') + 1, string?.lastIndexOf('#')))
}

export const parseReplyWithEqual = stringReply => {
  const [value, reply] = stringReply.split(' = ')

  return {
    replyValue: parseInt(value),
    stringReply: reply.trim()
  }
}

export const parseReplyWithHyphen = stringReply => {
  const [value, reply] = stringReply.split(' - ')

  return {
    replyValue: parseInt(value),
    stringReply: reply.trim()
  }
}

export const parseQuestion = stringReply => {
  const [questionNumber, question] = stringReply.split(' - ')

  return { questionNumber, question }
}

export const findRepliesByParentReference = (replies, reference) => {
  return replies.find(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const getResult = (value, calcBase) => {
  const numToCalc = calcBase / 3
  if (value === 3) return 3 * numToCalc
  if (value === 2) return 3 * numToCalc * 0.5
  if (value === 1) return 0
  if (value === 0) return 0
  return
}

export const sortAndReturnSelectedMoslerReplies = array => {
  return array
    .sort((a, b) => a.question.ordination - b.question.ordination)
    .map(item => {
      const questionReplyValue = item?.value?.name || item?.value
      const { replyValue, stringReply } = parseReplyWithHyphen(questionReplyValue)
      const categoryId = item?.question?.category?.id

      return {
        category: item?.question?.category?.name,
        question: item?.question?.name,
        questionId: item?.question?.id,
        replyValue,
        stringReply,
        categoryId
      }
    })
}

export const sortAndReturnSelectedReplies = array => {
  return array
    .sort((a, b) => a.question.ordination - b.question.ordination)
    .map(item => {
      const optionsReply = findRepliesByParentReference(array, item?.question?.reference)?.value

      if (optionsReply || item?.question?.type?.name === 'select') {
        const documents = item.documents.map(item => item.src)
        const calcBase = getQuestionValue(item.question?.description)
        const questionReplyValue = item?.value?.name || item?.value
        const { replyValue, stringReply } = parseReplyWithEqual(questionReplyValue)
        const maxValue = getResult(replyValue, calcBase)
        const minValue = replyValue === 0 ? calcBase : 0
        const value = calcBase
        const categoryId = item?.question?.category?.id
        const { questionNumber, question } = parseQuestion(item.question?.name)

        return {
          question,
          questionNumber,
          questionId: item?.question?.id,
          obs: optionsReply,
          replyValue,
          value,
          maxValue,
          minValue,
          documents,
          stringReply,
          categoryId
        }
      }
      return null
    })
    .filter(item => item !== null)
}

export const separateByCategoryId = array => {
  return array.reduce((acc, object) => {
    const categoryId = object.categoryId
    if (categoryId === 11) {
      acc['medidasProtecaoEletronica'] = acc['medidasProtecaoEletronica'] || []
      acc['medidasProtecaoEletronica'].push(object)
    }
    if (categoryId === 17) {
      acc['medidasProtecaoHumana'] = acc['medidasProtecaoHumana'] || []
      acc['medidasProtecaoHumana'].push(object)
    }
    if (categoryId === 13) {
      acc['medidasProtecaoFisica'] = acc['medidasProtecaoFisica'] || []
      acc['medidasProtecaoFisica'].push(object)
    }
    if (categoryId === 12) {
      acc['medidasProtecaoOrganizativa'] = acc['medidasProtecaoOrganizativa'] || []
      acc['medidasProtecaoOrganizativa'].push(object)
    }
    if (categoryId === 18) {
      acc['prevencaoCombateIncendios'] = acc['prevencaoCombateIncendios'] || []
      acc['prevencaoCombateIncendios'].push(object)
    }
    if (categoryId === 14) {
      acc['processoAtendimentoEmergenciaMedica'] = acc['processoAtendimentoEmergenciaMedica'] || []
      acc['processoAtendimentoEmergenciaMedica'].push(object)
    }
    if (categoryId === 22) {
      acc['acessibilidade'] = acc['acessibilidade'] || []
      acc['acessibilidade'].push(object)
    }
    if (categoryId === 21) {
      acc['heliponto'] = acc['heliponto'] || []
      acc['heliponto'].push(object)
    }
    if (categoryId === 23) {
      acc['incendioComVitimaFatal'] = acc['incendioComVitimaFatal'] || []
      acc['incendioComVitimaFatal'].push(object)
    }
    if (categoryId === 24) {
      acc['incendioSemVitimaFatal'] = acc['incendioSemVitimaFatal'] || []
      acc['incendioSemVitimaFatal'].push(object)
    }
    if (categoryId === 33) {
      acc['desinteligenciaSemVitimaFatal'] = acc['desinteligenciaSemVitimaFatal'] || []
      acc['desinteligenciaSemVitimaFatal'].push(object)
    }
    if (categoryId === 25) {
      acc['desinteligenciaComVitimaFatal'] = acc['desinteligenciaComVitimaFatal'] || []
      acc['desinteligenciaComVitimaFatal'].push(object)
    }
    if (categoryId === 26) {
      acc['furtosInternos'] = acc['furtosInternos'] || []
      acc['furtosInternos'].push(object)
    }
    if (categoryId === 27) {
      acc['rouboComVitimaFatal'] = acc['rouboComVitimaFatal'] || []
      acc['rouboComVitimaFatal'].push(object)
    }
    if (categoryId === 28) {
      acc['rouboSemVitimaFatal'] = acc['rouboSemVitimaFatal'] || []
      acc['rouboSemVitimaFatal'].push(object)
    }
    if (categoryId === 29) {
      acc['estupro'] = acc['estupro'] || []
      acc['estupro'].push(object)
    }
    if (categoryId === 30) {
      acc['acessoIndevidoTI'] = acc['acessoIndevidoTI'] || []
      acc['acessoIndevidoTI'].push(object)
    }
    if (categoryId === 31) {
      acc['obitoPosMalSubito'] = acc['obitoPosMalSubito'] || []
      acc['obitoPosMalSubito'].push(object)
    }
    if (categoryId === 32) {
      acc['ameacaBomba'] = acc['ameacaBomba'] || []
      acc['ameacaBomba'].push(object)
    }
    if (categoryId === 34) {
      acc['explosao'] = acc['explosao'] || []
      acc['explosao'].push(object)
    }
    if (categoryId === 35) {
      acc['suicidio'] = acc['suicidio'] || []
      acc['suicidio'].push(object)
    }
    return acc
  }, {})
}

export const sumMinValueByQuestionId = (array, questions) => {
  if (!array) return 0
  return array.filter(item => questions.includes(item.questionId)).reduce((total, item) => total + item?.minValue, 0)
}

export const sumMaxValueByQuestionId = (array, questions) => {
  if (!array) return 0
  return array.filter(item => questions.includes(item.questionId)).reduce((total, item) => total + item?.maxValue, 0)
}

export const sumValueByQuestionId = (array, questions) => {
  if (!array) return 0
  return array.filter(item => questions.includes(item.questionId)).reduce((total, item) => total + item?.value, 0)
}

export const sumMaxValues = array => {
  if (!array) return 0
  return array.reduce((total, item) => total + item?.maxValue, 0)
}

export const sumMinValues = array => {
  if (!array) return 0
  return array.reduce((total, item) => total + item?.minValue, 0)
}

export const sumTotalValues = array => {
  if (!array) return 0
  return array.reduce((total, item) => total + item?.value, 0)
}

export const calcReplyValue = (minValue, maxValue, totalValue) => {
  if (!minValue && !maxValue && !totalValue) return 0
  return parseFloat(((((maxValue * totalValue) / (totalValue - minValue)) * 100) / totalValue).toFixed(2))
}

export const calcResult = value => {
  if (!value) return 0
  return parseFloat((value === 100 ? 99.8 : value / 0.99999).toFixed(2))
}

export const getProtectionDegreeAverage = array => {
  if (!array.length) {
    return 0
  }
  const sum = array.reduce((acc, obj) => {
    return acc + obj.grauProtecao
  }, 0)

  const media = sum / array.length

  return media
}

export const getVulnerabilityDegreeAverage = array => {
  if (!array.length) {
    return 0
  }
  const sum = array.reduce((acc, obj) => {
    return acc + obj.grauVulnerabilidade
  }, 0)

  const media = sum / array.length

  return media
}

export const formatValue = value => {
  if (!value) return 0
  return parseFloat(value.toFixed(1))
}

export const formatRoundValue = value => {
  if (!value) return 0
  return Math.round(value * 10) / 10
}

export const getChartsData = value => {
  const type = value?.type

  if (type === 'andaresInternos' || type === 'recepcoes' || type === 'hallElevSS') {
    const MPE = value.medidasProtecaoEletronica
    const MPH = value.medidasProtecaoHumana
    const MPF = value.medidasProtecaoFisica
    const MPO = value.medidasProtecaoOrganizativa

    const array = [
      ...appendIf(MPE.result > 0, { label: MPE.label, percentage: formatRoundValue(MPE.result), value: MPE.result }),
      ...appendIf(MPH.result > 0, { label: MPH.label, percentage: formatRoundValue(MPH.result), value: MPH.result }),
      ...appendIf(MPF.result > 0, { label: MPF.label, percentage: formatRoundValue(MPF.result), value: MPF.result }),
      ...appendIf(MPO.result > 0, { label: MPO.label, percentage: formatRoundValue(MPO.result), value: MPO.result })
    ]

    const sum = array.reduce((acc, cur) => {
      return acc + cur.value
    }, 0)

    return [...array, { label: 'Média', percentage: formatRoundValue(sum / array.length), value: sum / array.length }]
  }

  if (type === 'sistemasGerais') {
    const PCI = value.prevencaoCombateIncendios
    const A = value.acessibilidade
    const PAEM = value.processoAtendimentoEmergenciaMedica
    const H = value.heliponto

    const array = [
      ...appendIf(PCI.result > 0, { label: PCI.label, percentage: formatValue(PCI.result) }),
      ...appendIf(A.result > 0, { label: A.label, percentage: formatValue(A.result) }),
      ...appendIf(PAEM.result > 0, { label: PAEM.label, percentage: PAEM.result }),
      ...appendIf(H.result > 0 > 0, { label: H.label, percentage: H.result })
    ]

    const sum = array.reduce((acc, cur) => {
      return acc + cur.percentage
    }, 0)

    return [...array, { label: 'Média', percentage: formatValue(sum / array.length) }]
  }
}

export const getResultDataCharts = value => {
  const categories = value.map(item => {
    return {
      type: item.type,
      label: item.title,
      percentage: formatRoundValue(item.grauProtecao),
      grauVulnerabilidadePercentage: item.grauVulnerabilidade
    }
  })

  const sum = categories.reduce((acc, cur) => {
    return acc + cur.percentage
  }, 0)

  const sumGrauVulnerabilidadePercentage = categories.reduce((acc, cur) => {
    return acc + cur.grauVulnerabilidadePercentage
  }, 0)

  return [
    ...categories,
    {
      label: 'Média',
      percentage: formatValue(sum / categories.length),
      grauVulnerabilidadePercentage: formatValue(sumGrauVulnerabilidadePercentage / categories.length)
    }
  ]
}

export const splitPlaceResume = input => {
  const parts = input.split(' - ')
  const [state, city, complex] = parts
  return { state, city, complex }
}

export const getMoslerValue = array => {
  const produto1 = array[0].replyValue * array[1].replyValue
  const produto2 = array[2].replyValue * array[3].replyValue
  const produto3 = array[4].replyValue * array[5].replyValue

  const soma = produto1 + produto2
  const resultadoFinal = soma * produto3

  return resultadoFinal
}

export const getMoslerRiskClass = valor => {
  if (valor > 1000) {
    return 'ELEVADO\n(1001 a 1250)'
  } else if (valor > 750) {
    return 'GRANDE\n(751 a 1000)'
  } else if (valor > 500) {
    return 'NORMAL\n(501 a 750)'
  } else if (valor > 250) {
    return 'PEQUENO\n(251 a 500)'
  } else if (valor > 1) {
    return 'MUITO BAIXO\n(2 a 250)'
  } else {
    return ''
  }
}

export const getMoslerVulnerabilityDegree = valor => {
  if (valor < 0 || valor > 100) {
    return ''
  } else if (valor < 20) {
    return 'MUITO BAIXO'
  } else if (valor < 40) {
    return 'BAIXO'
  } else if (valor < 60) {
    return 'MÉDIO'
  } else if (valor < 80) {
    return 'ALTO'
  } else {
    return 'MUITO ALTO'
  }
}

export const getAverageByType = array => {
  const groupedByType = array.reduce((acc, current) => {
    ;(acc[current.type] = acc[current.type] || []).push(current)
    return acc
  }, {})

  return Object.values(groupedByType).map(group => {
    const sumGrauProtecao = group.reduce((sum, item) => sum + item.grauProtecao, 0)
    const sumGrauVulnerabilidade = group.reduce((sum, item) => sum + item.grauVulnerabilidade, 0)

    const averageGrauProtecao = sumGrauProtecao / group.length
    const averageGrauVulnerabilidade = sumGrauVulnerabilidade / group.length
    const floors = group.map(item => item.floors)
    const andaresConcat = floors && floors.join(', ')
    const title = andaresConcat ? `${group[0].title} ${andaresConcat}` : group[0].title

    return {
      ...group[0],
      title,
      grauProtecao: averageGrauProtecao,
      grauVulnerabilidade: averageGrauVulnerabilidade
    }
  })
}

export const getMoslerList = (values, prevCombateIncendioValue, media) => {
  return Object.values(values).map(item => {
    const categoryId = item[0].categoryId
    const category = item[0].category
    const value = getMoslerValue(item)
    const classRisk = getMoslerRiskClass(value)

    const protectionDegreeCategories = [23, 24, 31]

    const grauProtecao = protectionDegreeCategories.includes(item[0].categoryId) ? prevCombateIncendioValue : media
    const grauVulnerabilidade = 99.8 - grauProtecao

    return {
      category,
      categoryId,
      value,
      classRisk,
      grauProtecao,
      grauVulnerabilidade
    }
  })
}

export const calcExtraValues = (sumMinValue, sumValue, sumMaxValue) => {
  if (sumMaxValue <= 0 && sumValue <= 0 && sumMaxValue <= 0) return 0
  const calc = (((sumMaxValue * sumValue) / (sumValue - sumMinValue)) * 100) / sumValue
  const result = calc === 100 ? 99.8 : calc / 0.99999
  return result
}

export const sumValueByCategoryId = (array, questions) => {
  if (!array) return 0
  const filteredArray = array.filter(item => questions.includes(item.categoryId))
  const sum = filteredArray.reduce((total, item) => total + item?.value, 0)
  return sum / filteredArray.length
}

export const sumGrauProtecaoByCategoryId = (array, questions) => {
  if (!array) return 0
  const filteredArray = array.filter(item => questions.includes(item.categoryId))
  const sum = filteredArray.reduce((total, item) => total + item?.grauProtecao, 0)
  return sum / filteredArray.length
}

export const sumGrauVulnerabilidadeByCategoryId = (array, questions) => {
  if (!array) return 0
  const filteredArray = array.filter(item => questions.includes(item.categoryId))
  const sum = filteredArray.reduce((total, item) => total + item?.grauVulnerabilidade, 0)
  return sum / filteredArray.length
}

export const getPrivateRiskLevelLabel = valor => {
  if (valor >= 1 && valor <= 20.99) {
    return 'MUITO BAIXO'
  } else if (valor >= 21 && valor <= 40.99) {
    return 'BAIXO'
  } else if (valor >= 41 && valor <= 60.99) {
    return 'MÉDIO'
  } else if (valor >= 61 && valor <= 80.99) {
    return 'ALTO'
  } else if (valor >= 81 && valor <= 100) {
    return 'MUITO ALTO'
  }
}

export const getPrivateRiskLevelPriority = valor => {
  if (valor >= 1 && valor <= 20.99) {
    return 'BAIXA'
  } else if (valor >= 21 && valor <= 40.99) {
    return 'MÉDIA'
  } else if (valor >= 41 && valor <= 60.99) {
    return 'ALTA'
  } else if (valor >= 61 && valor <= 80.99) {
    return 'IMPORTANTE'
  } else if (valor >= 81 && valor <= 100) {
    return 'URGENTE'
  }
}

export const getGRLevelLabel = valor => {
  if (valor >= 1 && valor <= 250.99) {
    return 'MUITO BAIXO'
  } else if (valor >= 251 && valor <= 500.99) {
    return 'PEQUENO'
  } else if (valor >= 501 && valor <= 750.99) {
    return 'NORMAL'
  } else if (valor >= 751 && valor <= 1000.99) {
    return 'GRANDE'
  } else if (valor >= 1001 && valor <= 1250) {
    return 'ELEVADO'
  }
}
